import React from 'react'

export default function Time() {
    return (
        <div>
            <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_171_2276)">
                    <path d="M34 17C34 26.3882 26.3882 34 17 34C7.61175 34 0 26.3882 0 17C0 15.8553 0.117583 14.739 0.3315 13.6581H3.2725C3.00617 14.7333 2.83333 15.844 2.83333 17C2.83333 24.8115 9.1885 31.1667 17 31.1667C24.8115 31.1667 31.1667 24.8115 31.1667 17C31.1667 9.1885 24.8115 2.83333 17 2.83333C13.8352 2.83333 10.9197 3.88733 8.56092 5.65108L11.4637 8.55383L1.53 10.472L3.44817 0.536917L6.54075 3.6295C9.42508 1.36567 13.0489 0 17 0C26.3882 0 34 7.61175 34 17ZM15.5833 8.5V19.8333H25.5V17H18.4167V8.5H15.5833Z" fill="#BB0600" />
                </g>
                <defs>
                    <clipPath id="clip0_171_2276">
                        <rect width="34" height="34" fill="white" />
                    </clipPath>
                </defs>
            </svg>

        </div>
    )
}
